"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthGuard } from "@/features/auth";
import type { ROLES } from "@/features/auth/api/types";
import { AppShell, PageContent, type PageContentProps } from "@/layouts/app-shell";
export type AuthenticatedPageLayoutProps = PageContentProps & {
  allowedRoles?: readonly ROLES[];
  /** Where AuthGuard sends unauthorized users. Defaults to "/". */
  redirectTo?: string;
};
export function AuthenticatedPageLayout(t0) {
  const $ = _c(12);
  let allowedRoles;
  let children;
  let pageContentProps;
  let redirectTo;
  if ($[0] !== t0) {
    ({
      children,
      allowedRoles,
      redirectTo,
      ...pageContentProps
    } = t0);
    $[0] = t0;
    $[1] = allowedRoles;
    $[2] = children;
    $[3] = pageContentProps;
    $[4] = redirectTo;
  } else {
    allowedRoles = $[1];
    children = $[2];
    pageContentProps = $[3];
    redirectTo = $[4];
  }
  let t1;
  if ($[5] !== children || $[6] !== pageContentProps) {
    t1 = <AppShell><PageContent {...pageContentProps}>{children}</PageContent></AppShell>;
    $[5] = children;
    $[6] = pageContentProps;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== allowedRoles || $[9] !== redirectTo || $[10] !== t1) {
    t2 = <AuthGuard allowedRoles={allowedRoles} redirectTo={redirectTo}>{t1}</AuthGuard>;
    $[8] = allowedRoles;
    $[9] = redirectTo;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}